<app-user-core-header></app-user-core-header>
<div class="pb-5 mb-5">
<app-user-core-menu></app-user-core-menu>
</div>
<div style="padding-left: 100px;  ">
<router-outlet></router-outlet>

</div>
 